import { DeleteIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";

import { ProjectList } from "@/api";
import { useStatusQuery } from "@/queries/query-status";

import { useDeleteReport } from "../api/delete-report";

export const ReportDeleteButton = ({ report }: { report: ProjectList }) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const { mutate } = useDeleteReport();
  const statusResponse = useStatusQuery();

  const isAdmin = statusResponse.data?.authenticated && statusResponse.data?.hasAdminAccess;

  if (!isAdmin || !report.slug) return null;

  return (
    <>
      <Modal isCentered isOpen={confirmModalOpen} onClose={() => setConfirmModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Weet je het zeker?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Weet je zeker dat je het rapport <Text as="strong">{report.name}</Text> wilt
            verwijderen?
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={() => setConfirmModalOpen(false)}>
              Annuleren
            </Button>
            <Button
              colorScheme="red"
              onClick={() => {
                if (!isAdmin || !report.slug) return null;
                mutate(report.slug);
                setConfirmModalOpen(false);
              }}
            >
              Verwijder
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Button onClick={() => setConfirmModalOpen(true)} minW={0} p={0} h={8} w={8} variant="danger">
        <DeleteIcon m={0} h={4} w={4} />
      </Button>
    </>
  );
};
